import { Box, Divider, Grid, Switch, TextField } from '@atgfr8/atg-ui-tailwind';
import { Accessor, Setter, Show } from 'solid-js';

import { InitialLTLFormValues } from '../Ltl';
import { defaultMargin as classes } from './classes';

const DefaultMargin = (props: {
  setFields: (key: string, value: unknown) => void;
  data: Accessor<InitialLTLFormValues>;
  setIsDirty: Setter<boolean>;
  onSectionChange: () => void;
}) => {
  return (
    <Box class="ml-0">
      <Box class={classes.mainText}>
        Set margins as a flat rate (a set dollar amount) or as a percentage of
        income on loads by carrier.
      </Box>
      <Box class={classes.defaultText}>Default Margins</Box>
      <Divider />
      <Box class={classes.itemsContainerSpace}>
        <Grid container size={12} class="ml-3!" spacing={1}>
          <Grid item size={2}>
            <Box class={classes.itemsStyle}>Type</Box>
          </Grid>
          <Grid item size={3.3} class={classes.itemsPadding}>
            <Box class={classes.itemsStyle}>Amount</Box>
          </Grid>
          <Grid item size={3.3} class={classes.itemsPadding}>
            <Box class={classes.itemsStyle}>Minimum</Box>
          </Grid>
          <Grid item size={3.3} class={classes.itemsPadding}>
            <Box class={classes.itemsStyle}>Maximum</Box>
          </Grid>
        </Grid>
        <Divider class={classes.dividerStyle} />
        <Grid container class={classes.switchContainer} spacing={1}>
          <Grid item size={2}>
            <Box class={classes.switchButtonContainer}>
              <Box
                class={`text-[16px] ${
                  props.data().ltlCostPlus.type === 'Percentage'
                    ? classes.greyText
                    : classes.blackText
                }`}
              >
                Flat
              </Box>
              <Switch
                aria-label="Margin type"
                dataTestId="default-margin-type-switch"
                checked={props.data().ltlCostPlus.type === 'Percentage'}
                onChange={(checked: boolean) => {
                  props.setFields('ltlCostPlus', {
                    ...props.data().ltlCostPlus,
                    type: checked ? 'Percentage' : 'Flat',
                  });
                  props.setFields('ltlCostPlus', {
                    ...props.data().ltlCostPlus,
                    minimum: null,
                  });
                  props.setFields('ltlCostPlus', {
                    ...props.data().ltlCostPlus,
                    maximum: null,
                  });
                  props.setIsDirty(true);
                  props.onSectionChange();
                }}
              />
              <Box
                class={`text-[16px] ${
                  props.data().ltlCostPlus.type === 'Percentage'
                    ? classes.blackText
                    : classes.greyText
                }`}
              >
                Percentage
              </Box>
            </Box>
          </Grid>
          <Grid item size={3.3} class={classes.itemsPadding}>
            <Grid container justifyContent="start">
              <Grid item size={11}>
                <TextField
                  type="number"
                  placeholder="Amount"
                  value={props.data().ltlCostPlus.amount ?? ''}
                  size="sm"
                  startIcon={
                    props.data().ltlCostPlus.type === 'Percentage'
                      ? undefined
                      : '$'
                  }
                  onChange={(val: string | number) => {
                    props.setFields('ltlCostPlus', {
                      ...props.data().ltlCostPlus,
                      amount: val,
                    });
                    props.setIsDirty(true);
                    props.onSectionChange();
                  }}
                  maxLength={16}
                  dataTestId="default-margin-amount-textInput"
                />
              </Grid>
              <Grid item size={0.5} class="mt-[6px]! ml-[4px]! text-[14px]!">
                {props.data().ltlCostPlus.type === 'Percentage' ? '%' : 'USD'}
              </Grid>
            </Grid>
          </Grid>
          <Show when={props.data().ltlCostPlus.type === 'Percentage'}>
            <Grid item size={3.3} class={classes.itemsPadding}>
              <TextField
                type="number"
                placeholder="Minimum"
                showInCurrencyFormat
                value={props.data().ltlCostPlus.minimum as number}
                size="sm"
                onChange={(val: unknown) => {
                  props.setIsDirty(true);
                  props.onSectionChange();
                  props.setFields('ltlCostPlus', {
                    ...props.data().ltlCostPlus,
                    minimum: val as number,
                  });
                }}
                maxLength={16}
                dataTestId="default-margin-minimum-textInput"
              />
            </Grid>
            <Grid item size={3.3} class={classes.itemsPadding}>
              <TextField
                type="number"
                placeholder="Maximum"
                showInCurrencyFormat
                value={props.data().ltlCostPlus.maximum as number}
                size="sm"
                onChange={(val: unknown) => {
                  props.setIsDirty(true);
                  props.onSectionChange();
                  props.setFields('ltlCostPlus', {
                    ...props.data().ltlCostPlus,
                    maximum: val as number,
                  });
                }}
                maxLength={16}
                dataTestId="default-margin-maximum-textInput"
              />
            </Grid>
          </Show>
        </Grid>
      </Box>
    </Box>
  );
};

export default DefaultMargin;
